const RECEIVE_OMNI_ENTITY = 'src/omniEntity/RECEIVE_OMNI_ENTITY' as const;

export default { RECEIVE_OMNI_ENTITY };
